import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionConfirmModel } from '../../../../models/action-confirm.model';
import { AcitivityMapRequestFind } from '../../../../models/api-store/activity-map/activity-map.request.model';
import { ActivityMapService } from '../../../../services/api-store/activity-map/activity-map.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../../utils/config/modal-settings';
import { ActionConfirmComponent } from '../../../ui/actionconfirm/actionconfirm.component';
import { FloatingItem } from '../../../ui/floatingbar/floatingbar-item';
import { ActivityMapCreateComponent } from './activity-map-create/activity-map-create.component';
import { ActivityMapEditComponent } from './activity-map-edit/activity-map-edit.component';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-activity-map',
  templateUrl: './activity-map.component.html'
})
export class ActivityMapComponent implements OnInit {

  public dimMax: number = 100;
  numeroPagina: number = 0;
  dimPagina: number = this.dimMax;
  public entityList: any = [];

  /**
   * Configura i button della floatingbar
   */
  public menuItems: FloatingItem[] = [
    {
      title: '',
      icon: 'fas fa-upload',
      choice: 'CREATE'
    }
  ];

  constructor(
    private activityMapService: ActivityMapService,
    private spinner: SpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.initTable();
  }




  /**
   * Inizializza la tabella
   */
  initTable() {
    let requestSearch = this.getFilter();
    this.activityMapService.findAll(requestSearch).subscribe(
      (response) => {
        this.setListEntityList(response);
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  setListEntityList(response) {
    if (response != null && typeof response != typeof undefined) {
      if (response.hasOwnProperty("data")) {
        this.entityList = [];
        for (let data of response.data) {
          this.entityList.push(data)
        }
      }
    }
  }

  getFilter() {
    let requestSearch = new AcitivityMapRequestFind();
    requestSearch.pageNumber = this.numeroPagina;
    requestSearch.pageSize = this.dimPagina;
    return requestSearch;
  }

  delete(id) {
    this.spinner.show();
    this.activityMapService.delete(id)
      .subscribe(
        (response: any) => {
          this.initTable()
          //Togli spinner
          this.spinner.hide();
          //Feedback all'utente
          this.toastr.success('Attività mappa cancellata con successo', 'Cancella attività mappa');
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.spinner.hide();
          this.toastr.error('Si è verificato un errore durante la cancellazione del attività mappa', 'Cancella attività mappa fallita', {
            timeOut: 5000
          });
        }
      );
  }

  clickButtonDelete(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.delete(id);
        }
      }
    });
  }

  clickButtonUpdate(id) {
    //Apre modale di modifica
    const modalRef = this.modalService.open(ActivityMapEditComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.id = id;
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        this.spinner.hide();
      }
    });
  }

  choiceButtonResponse($event) {
    if ($event == "CREATE") {
      //Apre modale di create
      const modalRef = this.modalService.open(ActivityMapCreateComponent, DIALOG_LARGE_CONFIG);
      modalRef.result.then(result => {
        if (result && result != "CLOSE") {
          this.entityList.push(result);
          //Togli spinner
          this.spinner.hide();
        }
      });
    }
  }






}
